import React from 'react';
import cs from 'classnames'
import css from './index.css';

export default class MiniSwiper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curIndex:0,
      leftpoint:0,
      rightpoint:0,
    }
  }
  componentDidMount() {
    
    this.setState({
      curIndex:0,
      leftpoint:0,
      rightpoint:2,
    })
  }
  turnDir = (dir) =>{
    const {curIndex} = this.state;
    let newIndex = curIndex + dir ;
    this.setState({
      curIndex: newIndex
    })
    this.turnBar(dir);
  }
  turnBar = (dir) => {
    const {animation} = this.state
    if(dir > 0) {

      this.setState({
        animation: animation === "right" ? "right2" : "right"
      })
    }else {
      this.setState({
        animation: animation === "left" ? "left2" : "left"
      })
    }
  }
  turnTo = (index) => {
    this.setState({
      curIndex: index
    }, ()=> {
      this.turnBar(index);
    })
  }
  renderPhotoList() {
    const {items} = this.props;
    const { length } = items
    const { curIndex, animation } = this.state;
    const renderList = [];
    for(let i = curIndex - 1; i < curIndex + 3 + 1 ; i++) {
      renderList.push( (i  % length) < 0 ?   (6 + i  % length) : (i  % length) )
    }
    return (
      <div className={css.photoBar}>
        <div 
          ref="photolist" 
          style={{position:'absolute',height:'100%',width:"100%", left: "-455px"}}
          className={cs({
            [css.turnLeft] : animation === "left",
            [css.turnRight] : animation === "right",
            [css.turnLeft2] : animation === "left2",
            [css.turnRight2] : animation === "right2",
          }
            

          )}
        >
          <div className={css.photoTrain}>
            {renderList.map((index)=>{
              const e = items[index];
              return (
                <a  
                  href={e.url}
                  target="_blank"
                  className={css.swiperCard}
                  onClick={e.click}
                >
                  <div className={cs(css.cardPic, e.pic)} >
                    
                  </div>
                  <div className={css.cardTitle}>
                    {e.title}
                  </div>
                  <div className={css.cardContent}>
                    {e.content}
                  </div>
                </a>
              )
            })}
          </div>
        </div>
        
        <div 
          className={cs(css.slidebarButton,css.leftbarSide)}
          onClick = {()=>this.turnDir(-1)}
        ></div>
        <div 
          className={cs(css.slidebarButton,css.rightbarSide)}
          onClick = {()=>this.turnDir(1)}
        ></div>
      </div>
    )
  }
  renderPoint() {
    const {curIndex} = this.state;
    const {items} = this.props;
    const { length } = items; 
    const points = new Array(length).fill("");
    const AniIndex = (curIndex  % length) < 0 ?   (6 + curIndex  % length) : (curIndex  % length)
    return (
      <div className={css.pointWarp}>
        {
          points.map((_, index) => {
            return (
              <div 
                className={cs(css.pointItem, {[css.pointItmeActive]: AniIndex === index})}
              > 
              </div>
            )
          })
        }
        <div></div>
      </div>

    )
  }
  render(){
    return (
      <div>
        {this.renderPhotoList()}
        {this.renderPoint()}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/MiniSwiper/index.js